module.exports = __webpack_public_path__ + "img/feature_buy_id.8ab0e374.png";